<ng-template #notification>
  <div class="notice">
    <i nz-icon nzType="info-circle"></i>
    <span style="margin-left: 2px;"><b>Exclusive Offer!</b></span>
    <span style="margin-left: 2px;">Get 50% Off your first 3 months! Use Coupon Code: </span>
    <a (click)="useCoupon()">QNE1stAI</a>
  </div>
</ng-template>

<nz-row class="wrapper">
  <nz-col class="left" nzMd="8" nzSm="24">
    <div class="big-text">50%</div>
    <div class="big-text">OFF</div>
    <div class="spaced-top">
      <div>ON YOUR FIRST 3</div>
      <div>MONTHS!</div>
    </div>
  </nz-col>

  <nz-col class="right" nzMd="16" nzSm="24">
    <div class="title">EXCLUSIVE OFFER!</div>
    <div class="description">
      <div>Unlock unbeatable savings and elevate</div>
      <div>your experience! Join us today with our</div>
      <div>exlcusive offer for first-time subscribers.</div>
      <div>Limited time only!</div>
    </div>
    <div class="coupon" (click)="useCoupon()">
      <div class="label">Use Coupon Code*:</div>
      <div class="code">QNE1stAI</div>
    </div>
    <div class="remark">
      <i>
        <div>*This coupon code cannot be combined</div>
        <div>with other offers or promotions.</div>
      </i>
    </div>
    <div class="image">
      <img src="https://cdn.qne.cloud/qca/assets/img/promo-code-girl.png" alt="promo" width="550" height="auto"/>
    </div>
  </nz-col>
</nz-row>
